import BaseHTMLColumnStrategy from './BaseHTMLColumnStrategy'

export default function BSHtmlAllTasksStrategy() {}

BSHtmlAllTasksStrategy.prototype = new BaseHTMLColumnStrategy();

BSHtmlAllTasksStrategy.prototype.getLevelsNumber = function () {
    return 2;
};

BSHtmlAllTasksStrategy.prototype.addFirstHeaderRowCells = function ( row/*, levelsNumber*/ ) {
    this.addCell( row, this.message( "report.billing_summary.overall_spent.detailed.superheader" ), "totalForAll", 3, 1 );
};

BSHtmlAllTasksStrategy.prototype.addSecondHeaderRowCells = function ( row, levelsNumber ) {
    var rowSpan = levelsNumber - 1;
    this.addCell( row, this.message( "report.billing_summary.overall_spent.detailed.overall" ), "subTotalSpent overall", 1, rowSpan );
    this.addCell( row, this.message( "report.billing_summary.overall_spent.detailed.billable" ), "subTotalSpent billable", 1, rowSpan );
    this.addCell( row, this.message( "report.billing_summary.overall_spent.detailed.nonbillable" ), "subTotalSpent nonBillable", 1, rowSpan );
};

BSHtmlAllTasksStrategy.prototype.addColumnValueCells = function ( row ) {
    this.addTimeValueCell(row);
    this.addTimeValueCell(row);
    this.addTimeValueCell(row);
};




// WEBPACK FOOTER //
// ./web/js/reports/preview/html/billingsummary/BSHtmlAllTasksStrategy.js